import { jsx as o, jsxs as l } from "react/jsx-runtime";
import { DialogClose as s } from "@radix-ui/react-dialog";
import e from "./index.es5843.js";
import { SearchField as m } from "./index.es45.js";
import { UtilityCloseLightIcon as d } from "./index.es445.js";
import { Divider as c } from "./index.es24.js";
const C = ({ hasCloseButton: t, children: i, search: r, testId: a }) => r ? /* @__PURE__ */ o(m, { ...r }) : /* @__PURE__ */ l("div", { "data-testid": a, className: e.actionsRoot, children: [
  t && /* @__PURE__ */ o(
    s,
    {
      "data-testid": "modal-close-button",
      "aria-label": "Close Modal",
      className: e.closeContainer,
      children: /* @__PURE__ */ o(d, {})
    }
  ),
  i && t && /* @__PURE__ */ o(c, { isVertical: !0, testId: "horizontal-divider" }),
  i
] });
export {
  C as HeaderActions
};
//# sourceMappingURL=index.es5741.js.map
